<template>
    <div>
        <v-row dense class="ma-0">
            <v-col cols="2">
            </v-col>
            <v-col cols="10">
                <h3 class="elementTitle">
                    <span>{{ title }}</span>
                </h3>
            </v-col>
        </v-row>
        <v-divider/>
        <v-row dense class="ma-0">
            <v-col cols="2" class="iconCol pt-2">
                <div v-html="icon">
                </div>
            </v-col>
            <v-col cols="10">
                <span class="adminDescription" v-html="description"></span>
            </v-col>
        </v-row>
        <v-row v-if="showChoices" dense class="ma-0 pa-0">
            <v-col cols="2"></v-col>
            <v-col cols="10">
                <v-select class="custom-placeholer-color" placeholder="Bitte wählen" solo flat v-model="choice" :items="choices" item-text="Value" item-value="ID" @change="showChoiceReport"/>
                <v-btn v-if="downloaded" text class="pa-0 ml-2" @click="reloadReport" plain>
                    <v-icon x-small class="mr-2">fa-arrows-rotate</v-icon>
                    <span>
                    Erneut laden...
                    </span>
                </v-btn>
            </v-col>
        </v-row>
        <v-row v-if="period" dense class="ma-0 pa-0">
            <v-col cols="2"></v-col>
            <v-col cols="10">
                <date-range-picker v-if="period===4" @dateRangeChanged="showReport" :disabled="disabled"/>
                <month-date-picker v-else-if="period === 3" @monthChanged="showReport" :disabled="disabled"/>
                <week-date-picker v-else-if="period === 2" @weekChanged="showReport" :disabled="disabled"/>
                <day-date-picker v-else-if="period === 1" @dayChanged="showReport" :disabled="disabled"/>
                <v-btn v-if="downloaded" text class="pa-0 ml-2" @click="reloadReport" plain>
                    <v-icon x-small class="mr-2">fa-arrows-rotate</v-icon>
                    <span>
                    Erneut laden...
                    </span>
                </v-btn>
            </v-col>
        </v-row>
        <v-row v-if="showChoices && period" dense class="ma-0 pa-0">
            <v-col cols="2"></v-col>
            <v-col cols="10">
                <v-btn text class="adminGotoLink pl-0" @click="showReport">
                    <span v-if="linkText">
                        {{ linkText }}
                    </span>
                    <span v-else>
                    Bericht anzeigen
                    </span>
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import WeekDatePicker from "@/components/general/WeekDatePicker.vue";
import DateRangePicker from "@/components/general/DateRangePicker.vue";
import DayDatePicker from "@/components/general/DayDatePicker.vue";
import MonthDatePicker from "@/components/general/MonthDatePicker.vue";

@Component({
    components: {WeekDatePicker, DateRangePicker, DayDatePicker, MonthDatePicker}
})
export default class ReportElement extends Vue {
    private get showChoices(): boolean {
        return this.choices && this.choices.length>0
    }
    private lastArgs: any = null;
    private disabled: boolean = false;
    @Prop()
    private linkText!: string | null;
    @Prop()
    private route!: string | null;
    @Prop() useSmallIcon!: boolean;
    @Prop({required: true}) title!: string;
    @Prop({required: true}) description!: string;
    @Prop({required: true}) icon!: string;
    @Prop({required: true}) reportNr!: any;
    @Prop({default: 0}) period!: number;

    private choice: number=0;

    @Prop({default: ()=>[]}) choices!: { ID:number, Value:string}[];

    private get downloaded(): boolean {
        return this.lastArgs !== null;
    }

    private reloadReport() {
        if (this.lastArgs) {
            this.$emit('showReport', this.lastArgs);
        }
    }

    private async showChoiceReport(): Promise<void> {
        if (this.period === 0) {
            this.lastArgs = {
                choice: this.choice,
                reportNr: this.reportNr,
                start: undefined,
                end: undefined,
                title: this.title //`${this.title} ${args.title.trim()}`
            };
            this.$emit('showReport', this.lastArgs);
        }
    }
    private showReport(args: { start: Date, end: Date, title: string }) {


        if(!this.showChoices) {
            if (this.period > 0 && args) {
                this.lastArgs = {
                    reportNr: this.reportNr,
                    start: args.start,
                    end: args.end,
                    title: `${this.title} ${args.title.trim()}`
                };
                this.$emit('showReport', this.lastArgs);
            }
        }
    }

    async mounted() {
        const config = JSON.parse(localStorage.getItem('Auth/userConfig') || '');
        if (!this.route) {
            this.disabled = config.permissions.REPORTS === 0;
        }
    }
}
</script>

<style>
.elementTitle > a {
    text-decoration: none;
    color: unset !important;
}

.iconCol > a {
    text-decoration: none;
}

.iconCol {
    text-align: center;
}

.adminIconLarge {
    font-size: 32px !important;
}

.adminDescription {

}

.adminGotoLink {
    padding-top: 6pt;
}

.custom-placeholer-color {

}
.custom-placeholer-color input::placeholder {
    color: black!important;
    opacity: 1;

}
</style>
